<template>
    <div class="coupon">
        <img src="../../../../assets/image/live/coupon.png" class="coupon-img" />
        <div class="info">
            <div class="title">{{voucher.vouchertemplate_points?voucher.vouchertemplate_points:'0'}} point(s) redemption</div>
            <div class="desc">满{{voucher.vouchertemplate_limit}}减{{voucher.vouchertemplate_price}}</div>
            <div class="btn"  @click="usecoupon">Get it now</div>
        </div>
        <img src="../../../../assets/image/live/close-w.png" class="close" @click="close"/>
    </div>
</template>

<script>
export default {
  props: {
    voucher: {}
  },
  data () {
    return {}
  },
  methods: {
    showgoods () {
      this.$emit('showgoods')
    },
    close () {
      this.$emit('hidecoupon')
    },
    usecoupon () {
      this.$emit('usecoupon')
    }
  },
  computed: {},
  created () {

  }
}
</script>
<style type="scss" scoped>
    .coupon {
        width: 11.70703125rem;
        height: 6.60234375rem;
        position: relative;
        margin: 0 auto;
    }
    .coupon-img {
        width: 11.70703125rem;
        height: 6.60234375rem;
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
    }
    .info {
        width: 11.70703125rem;
        height: 6.60234375rem;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
    }
    .title {
        font-family: PingFangSC-Medium;
        font-size: 0.7rem;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        line-height: 0.84375rem;
        margin-top: 0.99140625rem;
    }
    .desc {
        font-family: PingFangSC-Regular;
        font-size: 0.9rem;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        line-height: 1.0546875rem;
        margin-top: 0.65390625rem;
    }
    .btn {
        height: 1.35rem;
        width: 6.665625rem;
        background: #FFFFFF;
        border-radius: 0.833203125rem;
        border-radius: 0.833203125rem;
        padding: 0;
        font-family: PingFangSC-Regular;
        font-size: 0.7rem;
        color: #F16161;
        letter-spacing: 0;
        text-align: center;
        line-height: 1.35rem;
        margin:0 auto;
        margin-top: 0.9703125rem
    }
    .close{
        width: 1.096875rem;
        height: 1.096875rem;
        position: absolute;
        top: 0.421875rem;
        right: 0.421875rem;
        z-index: 2
    }
</style>
